import { useEffect } from "react";

export function useFiltersModal(isActive: boolean) {
  useEffect(() => {
    const main = document.querySelector("main");

    if (main) {
      main.style.pointerEvents = isActive ? "none" : "auto";
    }

    return () => {
      if (main) {
        main.style.pointerEvents = "auto";
      }
    };
  }, [isActive]);
}
